import { Component } from '@angular/core';

@Component({
  selector: 'app-checkout',
  standalone: false,
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.scss',
})
export class CheckoutComponent {
  paymentMethods = [
    {
      imagePath: '/images/paypal.png',
      title: 'PayPal',
    },
    {
      imagePath: '/images/visa.webp',
      title: 'Visa',
    },
    {
      title: 'Direct debit',
    },
    {
      title: 'Pre-payment',
    },
    {
      title: 'Invoice',
    },
  ];

}
